import {getDomainWithPrefix, getTimeStamp} from '@/common/util/common'
import { apiRequest, commonRequestInstanceToAxiosRequestInfo } from '@/common/api/api.service'
import {API_HAYSTACK_URL} from '@/common/constant'
import utils from '@/common/util/utils'
// 공통 개발 규격
const SERVICE = 'wavve'
const DEVICE = '8' // mobile web

export const HTTP_METHOD_POST = 'post'


// events
const URL_LOG_V2_EVENTS = `${API_HAYSTACK_URL}/apis/v1/events`
const LOG_TYPE_V2_EVENTS = 'uievent_search'
const LOG_TYPE_V2_EVENTS_VERSION = '2.5.6'

// ui event
const URL_LOG_V2_UI_EVENT = `${API_HAYSTACK_URL}/apis/v1/uievent`
const LOG_TYPE_V2_UI_EVENT = 'uievent'
const LOG_TYPE_V2_UI_EVENT_VERSION = '1.0.0'


/**
 * logData 를 받아 공통 개발규격을 만든다.
 * @param data
 * @param logType
 * @param logVersion
 * @returns {{log_timestamp: string, log_type: string, agent: string, app_version: string, zone: *, service: string, profileid: string, uno: string, log_version: string, device: number} & {data}}
 */
export const buildLogParameter = ({
  logType = '',
  logVersion = '',
  data = {},
}) => {
  const commonParam = {
    log_type: logType,
    log_version: logVersion, // Log 버전
    service: SERVICE, // 서비스 종류
    log_timestamp: getTimeStamp(), // Client Log 생성 시간
    uno: utils.cookies.getUno(), // 사용자 고유 번호
    profileid: utils.cookies.getProfileId(), // 사용자 프로필 고유번호
    zone: utils.cookies.getPooqZoneType(), // service zone type
    device: DEVICE, // 클라이언트 단말 구분
    agent: window.navigator.userAgent, // 클라이언트 agent 정보
    app_version: '' // app version
  }
  return {
    data: Object.assign({}, commonParam, { data })
  }
}

const catchFn = (error) => { console.log('[ERROR] : logv2', error) }

/**
 * 데이터를 받아 공통 개발규격으로 만들고 로그를 전송한다.
 * @param current
 * @param currentUrl
 * @param actionType
 * @param actionItem
 * @param actionParam
 * @param landing
 * @param landingParam
 * @param landingUrl
 * @returns {Promise<AxiosResponse>}
 */
export const sendClickLog = ({ current = '', currentUrl = '', actionType = '', actionItem = '', actionParam = {}, landing = '', landingParam = {}, landingUrl = '' }) => {
  return apiRequest(commonRequestInstanceToAxiosRequestInfo({
    url: getDomainWithPrefix(URL_LOG_V2_EVENTS),
    method: HTTP_METHOD_POST,
    needCommonParams: true,
    needCredential: true,
    data: buildLogParameter({
      logType: LOG_TYPE_V2_EVENTS,
      logVersion: LOG_TYPE_V2_EVENTS_VERSION,
      data: {
        current: current,
        current_url: currentUrl,
        action_type: actionType,
        action_item: actionItem,
        action_param: actionParam,
        landing: landing,
        landing_param: landingParam,
        landing_url: landingUrl
      }
    })
  }), catchFn)
}

/**
 * send log version 2 (on-click, on-display 이벤트)
 * 1차 검색 클릭로그와 동일한 규격으로 포멧하여 전송 (uievent3 => haystack)
 * @param list
 * @returns {Promise<AxiosResponse>}
 */
export const sendUiEventLog = ({ list = [] }) => {
  return apiRequest(commonRequestInstanceToAxiosRequestInfo({
    url: getDomainWithPrefix(URL_LOG_V2_UI_EVENT),
    method: HTTP_METHOD_POST,
    needCommonParams: true,
    needCredential: true,
    data: buildLogParameter({
      logType: LOG_TYPE_V2_UI_EVENT,
      logVersion: LOG_TYPE_V2_UI_EVENT_VERSION,
      data: { list }
    })
  }), catchFn)
}
